import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { DataObjectDescriptionVersionUrl } from '../../query/DataObjectDescriptionVersionUrl';
import {
  DeadlineGenerationFormType,
  ExecutionDeadlineFormDataType,
} from '../../schema';
import { ExecutionDeadlineSchema } from '../../schema/ExecutionFormDataSchema';

type GenerateDeadlinesParams = {
  dataObjectVersionId: number;
  formData: DeadlineGenerationFormType;
};

const generateDeadlines = ({
  dataObjectVersionId,
  formData,
}: GenerateDeadlinesParams) =>
  apiClient
    .post<ExecutionDeadlineFormDataType[]>(
      expand(DataObjectDescriptionVersionUrl.generateDeadlines, {
        id: dataObjectVersionId,
      }),
      formData,
    )
    .then((response) =>
      response.data.map((obj) => ExecutionDeadlineSchema.parse(obj)),
    );

export const useGenerateDeadlines = createApiMutationHook(
  ['generate-deadlines'],
  generateDeadlines,
);
